import {
    IOrderLine,
    ReferenceNumberType,
    ReferenceNumberTypeDomestic,
    ReferenceNumberTypeInternational
} from '@cod-monorepo/interfaces';
import { ViewMode } from '../../shared/enums/view-mode';
import { WorkflowError } from '../../shared/enums/workflow-error';

export class EvaluateSteps {
    static readonly type = '[Cod] Evaluate Steps';
    constructor(public summary?: boolean) {}
}

export class AddErrorMessage {
    static readonly type = '[Cod] Add Error Message';
    constructor(public error: WorkflowError) {}
}

export class RemoveErrorMessage {
    static readonly type = '[Cod] Remove Error Message';
    constructor(public error: WorkflowError) {}
}

export class RemoveTopErrorMessage {
    static readonly type = '[Cod] Remove Top Error Message';
}

export class ResetErrorMessages {
    static readonly type = '[Cod] Reset Error Messages';
}

export class LoadOrderLineItems {
    static readonly type = '[Cod] Load Order Line Items';
    constructor(
        public referenceNumber: string,
        public referenceNumberType:
            | ReferenceNumberTypeDomestic
            | ReferenceNumberTypeInternational
            | ReferenceNumberType
            | undefined
    ) {}
}

export class SetOrderLineItems {
    static readonly type = '[Cod] Set Order Line Items';
    constructor(public orderLineItems: IOrderLine[]) {}
}

export class SubmittCod {
    static readonly type = '[Cod] Submit Cod';
    constructor(public copyId?: string) {}
}

export class LoadCodById {
    static readonly type = '[Cod] Load Cod';
    constructor(public id: string) {}
}

export class SetViewMode {
    static readonly type = '[Cod] Set View Mode';
    constructor(public viewMode: ViewMode) {}
}

export class AddCurrentCodLine {
    static readonly type = '[Cod] Add Current Cod Line';
}

export class AttachCodLine {
    static readonly type = '[Cod] Attach Cod Line';
}

export class OpenForm {
    static readonly type = '[Cod] Open Form';
    constructor(public index: number) {}
}

export class ResetForm {
    static readonly type = '[Cod] Reset Form';
}

export class UpdateFormValidity {
    static readonly type = '[Cod] Update Form Validity';
    constructor(
        public form: 'referenceNumberDomesticStatus' | 'referenceNumberInternationalStatus' | 'affectedItemsStatus',
        public status: string
    ) {}
}

export class LoadAttachments {
    static readonly type = '[Cod] Load Attachments';
    constructor(public id: string) {}
}

export class CopyCod {
    static readonly type = '[Cod] Copy Cod';
    constructor(public id: string) {}
}

export class BackToForm {
    static readonly type = '[Cod] Back To Form';
}

export class ResetReferenceNumber {
    static readonly type = '[Cod] Reset Reference Number';
}
